import { cn } from '@/lib/utils';

/**
 * DayColumnHeader — Atom
 * One line, as in the practitioner calendar (Antonin, 13 Oct): "Tue 13" in the label role; today in the active blue
 * with a "Today" meta tag, on the blue-100 its whole column carries.
 */

interface DayColumnHeaderProps {
  dayOfWeek: string;
  date: number;
  isToday?: boolean;
  className?: string;
}

export function DayColumnHeader({ dayOfWeek, date, isToday = false, className }: DayColumnHeaderProps) {
  return (
    <div data-day-today={isToday ? '' : undefined} className={cn('flex h-10 items-center gap-2 px-3', isToday && 'bg-blue-100', className)}>
      <span className={cn('text-[length:var(--type-label-size)] font-medium leading-[var(--type-label-line)] tabular-nums', isToday ? 'text-brand-primary' : 'text-text-secondary')}>
        {dayOfWeek} {date}
      </span>
      {isToday && <span className="text-[length:var(--type-meta-size)] leading-[var(--type-meta-line)] text-brand-primary">Today</span>}
    </div>
  );
}
